/* eslint-disable */
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-add-loop-help',
  templateUrl: './add-loop-help.page.html',
  styleUrls: ['./add-loop-help.page.scss']
})
export class AddLoopHelpPage implements OnInit {
  constructor(private modalCtrl: ModalController) {}

  dismiss() {
    this.modalCtrl.dismiss();
  }

  ngOnInit() {}
}
